import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useRouterState } from "@tanstack/react-router";
import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { policiesVersion, TOS_MD, PRIVACY_POLICY_MD, RISK_DISCLOSURES_MD } from "../config/policies";

const TosModal = () => {
    const [open, setOpen] = useState(() => {
        const stored = sessionStorage.getItem(`tos-modal${policiesVersion}`);
        return stored ? JSON.parse(stored) : true;
    });

    useEffect(() => {
        sessionStorage.setItem(`tos-modal${policiesVersion}`, JSON.stringify(open));
    }, [open]);
    const routerState = useRouterState();
    const snackbar = useSnackbar();

    // If path begings with /md/ then we know we are on a markdown page so we skip the modal
    if (routerState.location.pathname.startsWith("/md/")) {
        return null;
    }

    return (
        <Dialog open={open} onClose={() => { }}>
            <DialogTitle>Acknowledge Terms</DialogTitle>
            <DialogContent>

                <Stack spacing={3}>
                    <Typography>
                        By accessing or using Euler's products and services, I agree to the <a href={TOS_MD} target="_blank" rel="noopener noreferrer">Terms of Use</a>, <a href={PRIVACY_POLICY_MD} target="_blank" rel="noopener noreferrer">Privacy Policy</a>, and <a href={RISK_DISCLOSURES_MD} target="_blank" rel="noopener noreferrer">Risk Disclosures</a>. I further represent and warrant:
                    </Typography>
                    <Typography>
                        I am not a resident of, located in, or incorporated in any Restricted Jurisdiction. I will not access this site or use our products or services while in any restricted locations, nor use a VPN to mask my location.
                    </Typography>
                    <Typography>
                        I am permitted to access this site and use Euler software under the laws of my jurisdiction.
                    </Typography>
                    <Typography>
                        I am not a Sanctioned Person (as defined in the ToU) nor acting on behalf of one.
                    </Typography>
                    <Typography>
                        The App, Protocol, and related software are experimental and may result in complete loss of funds. The company and its affiliates do not custody or control user assets or transactions; liquidations are performed by the protocol or its users.
                    </Typography>
                    <Typography>
                        I understand the risks of decentralised finance and engaging with blockchain and other web3 software and services, including technical, operational, market, liquidity, and legal risks.
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => snackbar.enqueueSnackbar("Must agree to use this application.", {variant: "error"})}>Reject</Button>
                <Button onClick={() => {setOpen(false)}} variant="contained">Accept</Button>
            </DialogActions>
        </Dialog>
    )
}

export default TosModal;